export default __webpack_public_path__ + "static/media/ucl.a4205e94.png";